import { useBulkActionsState } from './useBulkActionsState';
export const useBulkActionsHasError = () => {
  const state = useBulkActionsState();
  return Object.values(state.error).some(Boolean);
};